export default __webpack_public_path__ + "static/media/ST2-M_150_G.2c7f2b60.png";